import "./appMenu.scss";

import PropTypes from "prop-types";
import React from "react";

import hasAncestorOfClass, { hasAncestorWithClasses } from "../../utils/hasAncestorOfClass";
import AppMenuHotkeys from "./AppMenuHotkeys";
import AppMenuView from "./AppMenuView";

const clickWasMenuItem = e => hasAncestorOfClass(e.target, "appMenuItem");
const clickWasDisabledMenuItem = e => hasAncestorWithClasses(e.target, ["appMenuItem", "disabled"]);

class AppMenuBar extends React.Component {
  constructor(props) {
    super(props);

    this.state = { isMenuActive: false };

    this.onToggleMenu = this.onToggleMenu.bind(this);
  }

  componentWillUnmount() {}

  onToggleMenu() {
    this.setState({ isMenuActive: !this.state.isMenuActive });
  }

  render() {
    const onItemClick = (msgType, value) => {
      if (this.state.isMenuActive) {
        this.onToggleMenu();
      }
      this.props.onItemClick(msgType, value);
    };
    const onMouseDown = e => {
      const wasMenuItem = clickWasMenuItem(e);
      const wasDisabledMenuItem = clickWasDisabledMenuItem(e);
      if ((wasMenuItem || this.state.isMenuActive) && !wasDisabledMenuItem) {
        this.onToggleMenu();
      }
    };
    const className = `appMenuBar ${this.state.isMenuActive ? "active" : ""}`;

    return (
      <div className={className} onMouseDown={onMouseDown}>
        <div className="backdrop">
          <AppMenuHotkeys menuItems={this.props.menuItems} onItemClick={onItemClick} />
          <img className="appIcon" src={require("../../images/AppIcon.png")} />
          <AppMenuView
            menuItems={this.props.menuItems}
            onItemClick={onItemClick}
            depth={this.props.depth}
            canShowSubMenu={this.state.isMenuActive}
          />
        </div>
      </div>
    );
  }
}

AppMenuBar.propTypes = {
  depth: PropTypes.number.isRequired,
  menuItems: PropTypes.object.isRequired,
  onItemClick: PropTypes.func
};

export default AppMenuBar;
